import http from './httpRequest';

export const listLatestPublicMsgs = () => {
  return http({
    url: '/user/public-msg/list',
    method: 'get'
  });
};

export const listAllPublicMsgs = () => {
  return http({
    url: '/user/public-msg/all',
    method: 'get'
  });
};

export const getPublicMsg = (id) => {
  return http({
    url: `/user/public-msg/${id}`,
    method: 'get'
  });
};
